import { UserContentType } from "./types";

export type ContentMutationAction = "create" | "edit" | "delete";

export interface ContentMutationEventDetail {
    ownerId: string;
    contentType: UserContentType;
    action: ContentMutationAction;
    entityId?: string;
}

export const CONTENT_MUTATION_EVENT = "sf:content-mutated";

/**
 * Emit a global content mutation event so profile screens can refresh targeted content.
 */
export const emitContentMutation = (detail: ContentMutationEventDetail): void => {
    if (typeof window === "undefined") {
        return;
    }
    window.dispatchEvent(new CustomEvent<ContentMutationEventDetail>(CONTENT_MUTATION_EVENT, { detail }));
};
